<mat-progress-bar mode="determinate" color="accent" [value]="loader.progress$ | async" class="top-fixed" *ngIf="loader.progress$ | async"> </mat-progress-bar>

<pl-base-app>
  <router-outlet></router-outlet>
</pl-base-app>

<app-side-bar></app-side-bar>

<pl-tooltip-container></pl-tooltip-container>
